import React, { FC, useCallback, useRef } from 'react';

const IFRAME_HOST = window.location.origin;

interface HKPlayerFrameProps {
  domId: string;
  monitorLocation?: string;
  cameraUsername?: string;
  cameraPassword?: string;
  ipAddress?: string;
  port?: number;
  cameraPort?: number;
  rtspPort?: number;
  channelIndex?: number;
  enableFeature?: string;
  width?: number | string;
  height?: number | string;
}

const HKPlayerFrame: FC<HKPlayerFrameProps> = ({
  domId,
  monitorLocation,
  cameraUsername,
  cameraPassword,
  ipAddress,
  port,
  cameraPort,
  rtspPort,
  channelIndex,
  enableFeature,
  width = '100%',
  height = '100%',
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const postInitMessage = useCallback(() => {
    const iframe = iframeRef.current;
    if (!iframe) {
      return;
    }
    const rect = iframe.getBoundingClientRect();
    const frameWidth = Math.floor(rect.width);
    const frameHeight = Math.floor(rect.height);
    if (!frameWidth || !frameHeight) {
      return;
    }
    iframe.contentWindow?.postMessage(
      {
        domId,
        width: frameWidth,
        height: frameHeight,
        monitorLocation,
        cameraUsername,
        cameraPassword,
        ipAddress,
        port,
        cameraPort,
        rtspPort,
        channelIndex,
        enableFeatureList: (enableFeature || '')
          .split(',')
          .map(item => item.trim())
          .filter(Boolean),
        showTools: false,
        showFooter: false,
      },
      '*'
    );
    if (iframe.contentDocument) {
      iframe.contentDocument.body.style.minWidth = 'auto';
    }
  }, [
    cameraPassword,
    cameraPort,
    cameraUsername,
    domId,
    enableFeature,
    ipAddress,
    monitorLocation,
    port,
    rtspPort,
    channelIndex,
  ]);

  return (
    <iframe
      ref={iframeRef}
      src={`${IFRAME_HOST}/monitor/video/hkPlayer`}
      title="海康视频播放器"
      id={domId}
      width={width}
      height={height}
      frameBorder="0"
      onLoad={postInitMessage}
    />
  );
};

export default HKPlayerFrame;
